export const FACEBOOK_URL = "https://www.facebook.com/tillfinancial/"
export const TWITTER_URL = "https://www.twitter.com/tillfinancial/"
export const INSTAGRAM_URL = "https://www.instagram.com/tillfinancial/"
export const LINKEDIN_URL = "https://www.linkedin.com/company/tillfinancial/"

export const PARTNER_CONFIG = {
  "ef": {
    basePath: "/ef",
    faqPath: "/faq_travel",
    branchPath: "/EF-link",
    displayName: "EF Explore America",
    displayNameShort: "EF",
    showReferralCodeCTA: true,
    referralCode: "EF",
    campaignCode: "EFFALL2022",
    introVideoURL: "https://player.vimeo.com/video/700855575?h=488cfdf225",
    supportEmail: "ef@tillfinancial.io",
    language: {
      tourDirector: "Tour Director",
      groupLeader: "Group Leader",
      traveler: "Student",
    }
  },
  "edt": {
    basePath: "/edt",
    faqPath: "/faq_travel",
    branchPath: "/EDT",
    displayName: "Educational Discovery Tours",
    displayNameShort: "EDT",
    showReferralCodeCTA: false,
    referralCode: "",
    campaignCode: "EDT",
    introVideoURL: "",
    supportEmail: "edt@tillfinancial.io",
    language: {
      tourDirector: "Trip Leader",
      groupLeader: "Trip Organizer",
      traveler: "Student"

    }
  },
  "emerald": {
    basePath: "/emerald",
    faqPath: "/faq_travel",
    branchPath: "/emerald",
    displayName: "Emerald Student Travel",
    displayNameShort: "Emerald",
    showReferralCodeCTA: false,
    referralCode: "",
    campaignCode: "EMERALD",
    introVideoURL: "",
    supportEmail: "emerald@tillfinancial.io",
    language: {
      tourDirector: "Tour Director",
      groupLeader: "Trip Organizer",
      traveler: "Student"
    }
  },
  "progressive": {
    basePath: "/progressive",
    faqPath: "/faq",
    branchPath: "/e/ABOx7p08Mxb",
    displayName: "Progressive",
    displayNameShort: "Progressive",
    showReferralCodeCTA: true,
    referralCode: "PROGRESSIVE",
    campaignCode: "",
    introVideoURL: "",
    supportEmail: "help@tillfinancial.io",
    language: {
      tourDirector: "",
      groupLeader: "",
      traveler: ""
    }
  },
}
